import React from "react";
import ChangeInvoice from "./InvoiceModals/ChangeInvoice";
import MultipleReminders from "./InvoiceModals/MultipleReminders";
import ChangeInvoiceNote from "./InvoiceModals/ChangeInvoiceNote";
import SubmitInvoice from "./InvoiceModals/SubmitInvoice";
import QbDocument from "./InvoiceModals/QbDocument";
import DeleteInvoice from "./InvoiceModals/DeleteInvoice";

const InvoiceModals = ({ activeModal, handleCloseModal }) => {
  return (
    <>
      <ChangeInvoice
        isOpen={activeModal === "changeInvoice"}
        onClose={handleCloseModal}
      />
      <MultipleReminders
        isOpen={activeModal === "reminder"}
        onClose={handleCloseModal}
      />
      <ChangeInvoiceNote
        isOpen={activeModal === "note"}
        onClose={handleCloseModal}
      />
      <SubmitInvoice
        isOpen={activeModal === "email"}
        onClose={handleCloseModal}
      />
      <QbDocument isOpen={activeModal === "addQb"} onClose={handleCloseModal} />
      <DeleteInvoice
        isOpen={activeModal === "delete"}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default InvoiceModals;
